import styled from 'styled-components';
import { IButtonProps } from '.';

export const ButtonStyled = styled.button<IButtonProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  cursor: pointer;
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;

  &:focus-visible {
    outline: none;
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  ${({ customVariant }) => {
    switch (customVariant) {
      case 'destructive':
        return 'background-color: #e74c3c; color: #ffffff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); &:hover { background-color: rgba(231, 76, 60, 0.9); }';
      case 'outline':
        return 'border: 1px solid #3498db; background-color: transparent; color: #3498db; &:hover { background-color: rgba(52, 152, 219, 0.1); }';
      case 'secondary':
        return 'background-color: #2ecc71; color: #ffffff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); &:hover { background-color: rgba(46, 204, 113, 0.9); }';
      case 'ghost':
        return 'background-color: transparent; color: #161616f4; &:hover { background-color: #F5F5F5; }';
      case 'link':
        return 'background-color: transparent; color: #3498db; text-decoration: underline; &:hover { background-color: rgba(52, 152, 219, 0.1); }';
      default:
        return 'background-color: #3498db; color: #ffffff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); &:hover { background-color: rgba(52, 152, 219, 0.9); }';
    }
  }}
  ${({ size }) => {
    switch (size) {
      case 'sm':
        return 'height: 32px; padding: 0 12px; font-size: 12px;';
      case 'lg':
        return 'height: 40px; padding: 0 16px; font-size: 16px;';
      case 'icon':
        return 'height: 32px; width: 32px;';
      default:
        return 'height: 36px; padding: 0 16px; font-size: 14px;';
    }
  }}
`;
